import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom'; // добавили Link
import { getNewsById } from '../api';
import ImageLightbox from '../components/ImageLightbox';

const NewsDetail = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return null;
    if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) return imgPath;
    if (imgPath.startsWith('/uploads/')) return `http://localhost:5000${imgPath}`;
    return `http://localhost:5000/uploads/news/${imgPath}`;
  };

  useEffect(() => {
    getNewsById(id)
      .then(data => setNews(data))
      .catch(console.error);
  }, [id]);

  const handleImageClick = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  if (!news) return <div>Загрузка...</div>;

  const images = news.images ? news.images.map(getImageUrl) : [];

  return (
    <>
      <div className="container" style={{ marginTop: '40px', marginBottom: '40px' }}>
        <h1>{news.title}</h1>
        <div className="news-date">
          {new Date(news.date).toLocaleDateString('ru-RU')}
        </div>

        {images.length > 0 && (
          <div style={{ margin: '20px 0', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {images.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt=""
                style={{ width: '200px', height: '150px', objectFit: 'cover', cursor: 'pointer', borderRadius: '4px' }}
                onClick={() => handleImageClick(idx)}
              />
            ))}
          </div>
        )}

        <div dangerouslySetInnerHTML={{ __html: news.fullText }} />

         {/* Кнопка перехода в архив */}
        <div className="archive-button-wrapper" style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Link to="/archived-news" className="btn-archive">📂 Просмотреть архив новостей</Link>
        </div>
      </div>

      {lightboxOpen && (
        <ImageLightbox
          images={images}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
};

export default NewsDetail;